import React from "react";
import ReactDOM from "react-dom";
import MapSection from "../components/MapSection/MapSection";
import getRowData from "../assets/store/getRowData";
import { getDefaultFontFamily } from "../assets/store/getDefaultFontFamily";
import getMapSectionHours from "../assets/store/getMapSectionHours";

const renderMapSection = () => {
    const rows = document.getElementsByClassName("ds-map-section-row");
    const drive_service_divs = window.DriveServiceSpecials.drive_service_divs;
    const client = window.DriveServiceSpecials.client;
    const weather_config = window.DriveServiceSpecials.weather_config;
    const oems = window.DriveServiceSpecials.oems;
    const {
        default_oem,
        google_business_hours,
        active_client_hours,
        parts_hours,
        parts_hours_saturdays,
        parts_hours_sundays,
        service_hours,
        service_hours_saturdays,
        service_hours_sundays,
    } = client;

    let custom_hours_obj = {
        service: {
            service_hours,
            service_hours_saturdays,
            service_hours_sundays,
        },
        parts: {
            parts_hours,
            parts_hours_saturdays,
            parts_hours_sundays,
        },
        special: active_client_hours,
    };
    let map_section_hours = getMapSectionHours(
        google_business_hours,
        custom_hours_obj
    );

    const { longitude, latitude } = weather_config || {
        longitude: null,
        latitude: null,
    };

    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const parent = drive_service_divs.find(
            (div) =>
                div.id === parseInt(row.parentElement.id.replace("ds-div-", ""))
        );
        let rowData = getRowData(parent.div_rows, parseInt(row.id));
        const {
            selected_map_section_url,
            use_custom_map_url,
            map_section_url,
        } = rowData;
        let commonDataAttr = {
            "data-divid": parent.id,
            "data-rowid": row.id,
            "data-clientid": client.id,
        };
        let mapSectionProps = {
            client,
            selected_map_section_url,
            use_custom_map_url,
            map_section_url,
            longitude,
            latitude,
            oem: default_oem || oems[0] || null,
            dataAttributes: commonDataAttr,
            rowData,
            map_section_hours,
        };
        ReactDOM.render(<MapSection {...mapSectionProps} />, row);
    }
};

if (process.env.REACT_APP_ENVIRONMENT !== "local") renderMapSection();
window.renderMapSections = renderMapSection;
export default renderMapSection;
